import Button from "../components/Button";
import styles from "./SignIn.module.css";

interface SignInProps {
  /** Message from a failed or refused authentication attempt, if any. */
  error: string | null;
  /** False when the KochID environment variables are absent. */
  isConfigured: boolean;
  onSignIn: () => void;
}

/**
 * The fallback screen for when automatic sign-in cannot proceed. An
 * authenticated visitor never sees this, and an unauthenticated one is
 * normally redirected straight to KochID without a button (see App.tsx). This
 * renders only in the two cases where an automatic redirect would be wrong:
 *
 *  - KochID is not configured for this environment — there is nowhere to send
 *    the user, so explain rather than loop.
 *  - A previous attempt failed — auto-redirecting on an error would loop
 *    endlessly, so the user retries deliberately.
 */
function SignIn({ error, isConfigured, onSignIn }: SignInProps) {
  return (
    <div className={styles.screen}>
      <section className={styles.panel}>
        <h1 className={styles.title}>Inventory</h1>

        {isConfigured ? (
          <p className={styles.body}>Sign-in didn’t complete. Try again to continue.</p>
        ) : (
          <p className={styles.body}>
            KochID is not configured for this environment. Set the
            <code> VITE_KOCHID_*</code> variables and rebuild.
          </p>
        )}

        {error && <div className={styles.error}>{error}</div>}

        <Button variant="primary" onClick={onSignIn} disabled={!isConfigured}>
          Try again
        </Button>
      </section>
    </div>
  );
}

export default SignIn;
